import React, { PropsWithChildren } from "react";
import { useProjectItemMap } from "../Hooks/UseProjectItemMap";
import { IProjectItemContextProviderProps } from "./IProjectItemContextProviderProps";
import { ProjectItemContext } from "./ProjectItemContext";

export function ProjectItemContextProvider(props: PropsWithChildren<IProjectItemContextProviderProps>): JSX.Element {
  const { type, children } = props;
  const projectItemMap = useProjectItemMap(type);
  return <ProjectItemContext.Provider value={projectItemMap}>{children}</ProjectItemContext.Provider>;
}
